module.exports = __webpack_public_path__ + "img/seeburg_mini.9bf07cc4.png";